<p-floatLabel>
  <p-select #serviceSelector
        id="serviceSelector"
        name="serviceSelector"
        [options]="servicesFiltered"
        [(ngModel)]="selectedService"
        [showClear]="true"
        [checkmark]="true"
        [filter]="true"
        styleClass="w-100"
        [disabled]="isDisabled"
        (onChange)="onSelected()"
        optionLabel="name">
    <ng-template let-option pTemplate="item">
      {{ option?.name }}
    </ng-template>
  </p-select>
  <label for="serviceSelector">
    <app-label-content [isRequired]="isRequired">
      {{ l('::Service') }}
    </app-label-content>
  </label>
</p-floatLabel>